export function buildQuery(queryObj) {
  let query = [];
  for (let key in queryObj) {
    if (![undefined, null, ""].includes(queryObj[key])) {
      query.push(
        encodeURIComponent(key) + "=" + encodeURIComponent(queryObj[key])
      );
    }
  }
  return query.length ? "?" + query.join("&") : "";
}
export const walletTransaction = {
  getWalletTransaction: (data) => {
    return window.axios.get(`get-wallet-transactions${buildQuery(data)}`);
  },
};
